/* toc.ts — scroll-spy for the sidebar table of contents.
 *
 * The ToC itself is generated at build time by jekyll-toc and rendered inside the
 * active nav item by _includes/nav.html. This file only tracks which section is
 * currently in view.
 *
 * Deliberately rAF-throttled getBoundingClientRect rather than IntersectionObserver:
 * IO answers "is this element visible", not "which section am I inside", so using it
 * for scroll-spy needs a rootMargin hack plus extra handling for the top of the page
 * and the last section. A throttled scan over a handful of headings costs one frame
 * and stays correct when MathJax reflows the page after load.
 */

(function () {
    'use strict';

    const links = Array.from(document.querySelectorAll<HTMLAnchorElement>('.nav-toc a[href^="#"]'));
    if (links.length === 0) {
        return;
    }

    const targets = links
        .map(function (a) {
            try {
                return document.getElementById(decodeURIComponent(a.hash.slice(1)));
            } catch (_e) {
                return null;
            }
        });

    let ticking = false;

    function update() {
        ticking = false;

        /* A heading counts as "current" once it has scrolled above this line. */
        const line = 96;
        let active = -1;

        targets.forEach(function (heading, i) {
            if (heading && heading.getBoundingClientRect().top <= line) {
                active = i;
            }
        });

        links.forEach(function (a, i) {
            a.classList.toggle('is-current', i === active);
        });
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
})();
